import React from "react";
import "./navbar.css";
import { NavLink } from "react-router-dom";

import { ReactComponent as Heart } from "../../assets/icons/heart_fill.svg";

import { ReactComponent as Home } from "../../assets/icons/home_fill.svg";

import { ReactComponent as Location } from "../../assets/icons/location_fill.svg";

import { ReactComponent as User } from "../../assets/icons/user.svg";

const Navbar = () => {
  const commonStyle = `sticky bottom-0 z-40 flex items-center justify-center p-4 
    text-gray-900 dark:text-gray-200 
    dark:bg-gray-900 bg-white shadow-top dark:shadow-slate-600	`;
  const mobileStyle = `w-screen  

  `;

  return (
    <div className={`${commonStyle} ${mobileStyle} `}>
      <NavLink
        to="/"
        className={({ isActive }) => (isActive ? "nav navActive" : "nav")}
      >
        <Home />
      </NavLink>
      <NavLink
        to="/favorite"
        className={({ isActive }) => (isActive ? "nav navActive" : "nav")}
      >
        <Heart />
      </NavLink>
      <NavLink
        to="/location"
        className={({ isActive }) => (isActive ? "nav navActive" : "nav")}
      >
        <Location />
      </NavLink>
      <NavLink
        to="/user"
        className={({ isActive }) => (isActive ? "nav navActive" : "nav")}
      >
        <User />
      </NavLink>
    </div>
  );
};

export default Navbar;
